
    import { defineComponent } from 'vue';

    export default defineComponent({
        name: "UICopyToClipboard",
        props: {
            value: { type: String, required: true }
        },
        data() {
            return {
                copied: false
            };
        },
        computed: {
            canCopy(): boolean {
                return !!navigator.clipboard && this.value?.length > 0;
            }
        },
        methods: {
            copyToClipboard() {
                navigator.clipboard.writeText(this.value);
                this.copied = true;
                setTimeout(() => { this.copied = false; }, 3000);   //Show success message for 3 seconds
            }
        }
    });
